<div *ngFor="let link of links">
  <a class="link" (click)="goTo(link)">{{ link.text | translate }}</a>
</div>
